export { default } from './BooleanCellContent';
